import { fetchPlaybooks, fetchRecommendedPlaybooks } from './cardListActionTypes';
import Raven from 'raven-js';
export const fetch = ({
  offset = 0,
  searchText
} = {}) => (dispatch, getState, service) => {
  const limit = service.playbookListLimit;
  const query = searchText === undefined ? getState().searchText : searchText;
  dispatch(fetchPlaybooks.pending({
    offset,
    searchText: query,
    limit
  }));
  return service.fetchPlaybooks({
    query,
    offset,
    limit
  }).then(res => {
    dispatch(fetchPlaybooks.fulfilled(res));
  }).catch(err => {
    dispatch(fetchPlaybooks.rejected(`${err}`));
    Raven.captureException(err);
  });
};
export const fetchRecommendations = (objectType, objectId) => (dispatch, getState, service) => {
  dispatch(fetchRecommendedPlaybooks.pending());
  return service.fetchRecommendedPlaybooks(objectType, objectId).then(res => dispatch(fetchRecommendedPlaybooks.fulfilled(res))).catch(err => {
    dispatch(fetchRecommendedPlaybooks.rejected(`${err}`));
    Raven.captureException(err);
  });
};